import { ISearchPage } from '@/types/AppTypes';

//详情
export interface IPurchaseDetail {
	id: string; // '外贸合同id';
	code: string; // '采购合同单号';
	purchaseCode?: string; // '采购合同单号';
	offerCode?: string; // '报价单号';
	shopCode?: string; // '门店编码';
	shopName?: string; // '门户名称';
	supplierId?: string; // '供应商id';
	supplierCode?: string; // '供应商编号';
	supplierName?: string; // '供应商名称';
	contact?: string; // '供应商联系人';
	phone?: string; // '供应商联系电话';
	advise?: string;
	adviseOne?: string;
	supplierTypeCode?: string; // '供应商类型';
	supplierTypeName?: string; // '供应商类型名称 ';
	typeNum?: string | number; // '发票类型';
	country?: string; // '贸易国别';
	status?: string; // '状态';
	signingTime?: moment.Moment | null | string; // '签约日期';
	signingAddress?: string; // '签约地点';
	deliver?: moment.Moment | null | string; // '交货日期';
	exWarehouseTime?: moment.Moment | null | string; // '交货日期';
	amountTotal?: string | number; // '金额';
	saleCode?: string; // '外贸合同号';
	typeCode?: string; // '采购类型';
	typeName?: string; // '采购类型名称';
	deliveryTime?: string; // '出库日期';
	settlementTime?: moment.Moment | null | string; // '结算日期';
	payTime?: string; // '结款日期';
	reckoner?: string; // '财务';
	totalTxt?: string; // '财务';
	note?: string; // '1.2';
	relevanceOrderId?: string; // '1.2';
	estimatedTime?: moment.Moment | null | string;
	details?: IPurchasesMaterial[];
	detailsPayment?: IPurchasesDetailMethod[];
	createTime?: moment.Moment | null | string;
	updateTime?: moment.Moment | null | string;
}
export interface IPurchasesMaterial {
	key?: string;
	id?: string; // '采购合同明细id';
	purchaseId?: string; // '采购合同id';
	purchaseCode?: string; // '采购合同单号';
	materialId?: string; // '物料id';
	materialCode?: string; // '物料编号';
	materialName?: string; // '物料名称';
	materialEname?: string; // '物料名称英文';
	replaceCode?: string; // '替换号';
	typeCode?: string; // '物料类型';
	typeName?: string; // '物料类型名称';
	model?: string; // '规格';
	num?: string | number; // '询价数量';
	price?: string | number; // '单价';
	amount?: string | number; // '总金额';
	warehouseCode?: string; // '仓库code';
	warehouseName?: string; // '仓库名称';
	shelfCode?: string; // '货位';
	note?: string; // '备注';
	totalTxt?: string; // '备注';
	"unitCode"?: string; // 
	"unitName"?: string; // "单位",
	"customsCode"?: string; // "单位",
}
//新增
export interface IPurchasesInsert { }

//编辑
export interface IPurchasesUpdate extends IPurchasesInsert {
	id: string;
	code: string;
}

//收汇方式
export interface IPurchasesDetailMethod {
	key: string;
	amount?: string | number; // 65
	around?: string; // "或前"
	certificatesTime?: moment.Moment | null | string; // "预计收证日期"
	code?: string; // "询-999-21121400001"
	collectionTime?: moment.Moment | null | string; // "预计收款日期"
	createTime?: string; // "2021-12-14T20:45:38"
	createUser?: string; // null
	deleteFlag?: string; // 0
	id?: string; // "1"
	orderNum?: string; // 0
	paymentMethod?: string; // "收汇方式"
	paymentTime?: moment.Moment | null | string; // "日期"
	proportion?: string; // "比例"
	updateTime?: string; // "2021-12-14T20:46:29"
	updateUser?: string; // null
}

//搜索条件
export interface IPurchasesSearchFields { }

export interface IPurchasesSearch extends IPurchasesSearchFields, ISearchPage { }

/**
 * 详情s
 */
//tab枚举
export enum IPurchaseTabEnum {
	MATERIAL_INFO = 'material_info', //商品信息
	FILES = 'files', //附件管理
	AUDIT_DETAIL = 'Audit_detail', //审批明细
}

export interface IPurchaseExamine {
	id?: string; // "ecf65d81b424438f937565cee152a7f5",
	code?: string; // "ecf65d81b424438f937565cee152a7f5",
	status?: string; // "0",
	advise?: string; // "审批意见1111"
	title?: string;
}

//底部展示所有总计类型
export type IPurchaseDescType = {
	numAll: number,
	amountAll: number,
	[key: string]: any
}

